import {ImpuestoDTO} from './ImpuestoDTO';
import {TipoRetencionDTO} from './TipoRetencionDTO';
import {ReferenciaCFEDTO} from './ReferenciaCFEDTO';
import {DetalleTipoCodigoDTO} from './DetalleTipoCodigoDTO';

export class DetalleCFEDTO
{
  nombre: string;
  cantidad: number;
  precioUnitario: number;
  precioVenta: number;
  impuesto: ImpuestoDTO;
  montoIVA: number;
  montoTotal: number;
  tipoCodigos: DetalleTipoCodigoDTO[] = [];
  tipoPeso: string;
  tieneIVAIncluido: boolean = false;

  // Propiedades de e-Resguardos (Inicio).
  tipoRetencionEResg: TipoRetencionDTO;
  tasaEResg: number;
  montoSujetoARetencionEResg: number;
  montoRetenidoEResg: number;
  referenciaCFEEResg: ReferenciaCFEDTO;
  // Propiedades de e-Resguardos (Fin).

  descripcionAdicional: string;

  toString(): string
  {
    const detalleCFEDTOStr: string = '(Nombre: ' + this.nombre + ', Cantidad: ' + this.cantidad + ', ' +
      'Precio unitario: ' + this.precioUnitario + ', Precio venta: ' + this.precioVenta + ', ' +
      'Impuesto: ' + this.impuesto.descripcion + ', Monto IVA: ' + this.montoIVA + ', ' +
      'Monto total: ' + this.montoTotal + ')';

    return detalleCFEDTOStr;
  }
}
